import type { Theme } from "@mui/material";

export const getRagColor = (ragColor: string, theme: Theme): string => {
  switch (ragColor.toLowerCase()) {
    case "green":
      return theme.palette.success.main;
    case "amber":
      return theme.palette.warning.main;
    case "red":
      return theme.palette.error.main;
    default:
      return theme.palette.warning.main;
  }
};
